import { modifier } from 'ember-modifier';
export default modifier(function (element, _, {
  shouldPersist
}) {
  if (element.tagName.toLowerCase() !== 'market-toast') {
    throw new Error('Only use on a market-toast element');
  }
  if (!shouldPersist) {
    element.startAutoDismissTimer();
  }
});